
import { IOfferAttributeName, offersModel } from '../../../models/offers.model';
import { Component, Vue } from 'vue-property-decorator';
import PazAttributesDialog from "../../../components/dialog/PazOrderAttributeDialog.vue"
import AttributesTab from "../../../components/dialog/tabs/AttributesTab.vue";
import { getOfferAttributes } from '../../../services/offers-service';

@Component({
  components: {
    PazAttributesDialog,
    AttributesTab
  }
})
export default class OfferAttributesMixin extends Vue {

  public offerAttributeNames: IOfferAttributeName[] = [];
  public showAttributesModal: boolean = false;


  async showAttributeModal(offerInstance: offersModel) {
    this.selectedOffer = offerInstance;
    this.showAttributesModal = true;
    this.offerAttributeNames = await getOfferAttributes();
  }


  getAttributesCount(offer: offersModel) {
    return offer.attributeValue.length > 0 ? offer.attributeValue.length : false;
  }




}//
